module.exports = "<template>\r\n\t<a href=\"#\" click.delegate=\"edit()\">${value ? value : '(empty)' | date}</a>\r\n</template>";